import { routeConstants } from "shared/constants/route"
import Policy from './Policy'

const PolicyRoute = {
    path: routeConstants.POLICY.route,
    component: Policy
}

export default PolicyRoute